import React from 'react'
import "./Signup.css"
import logoImage from "../../images/wosender.svg";

function Signup() {
  return (
    <div className='WoSender-signup-Signup'>
      <div className="WoSender-signup-container">

        <div className="WoSender-signup-triangle WoSender-signup-triangle-dark WoSender-signup-triangle1"></div>
        <div className="WoSender-signup-triangle WoSender-signup-triangle-dark WoSender-signup-triangle2"></div>
        <div className="WoSender-signup-triangle WoSender-signup-triangle-dark WoSender-signup-triangle3"></div>

        <div className="WoSender-signup-triangle WoSender-signup-triangle-light WoSender-signup-triangle4"></div>
        <div className="WoSender-signup-triangle WoSender-signup-triangle-light WoSender-signup-triangle5"></div>
        <div className="WoSender-signup-triangle WoSender-signup-triangle-light WoSender-signup-triangle6"></div>

        <img className='WoSender-signup-logo-placeholder' src={logoImage} alt="" />
        <p className='WoSender-signup-heading'>Create Your Account</p>

        <form>
          <div className="WoSender-signup-form-group">
            <label htmlFor="name">Full Name</label>
            <input type="text" id="name" name="name" required />
          </div>

          <div className="WoSender-signup-form-group">
            <label htmlFor="email">Work Email</label>
            <input type="email" id="email" name="email" required />
          </div>

          <div className="WoSender-signup-form-group">
            <label htmlFor="phone">Phone Number</label>
            <input type="tel" id="phone" name="phone" required />
          </div>

          <div className="WoSender-signup-form-group">
            <label htmlFor="company">Company Name</label>
            <input type="text" id="company" name="company" required />
          </div>

          <div className="WoSender-signup-form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" name="password" required />
          </div>

          <button type="submit" className="WoSender-signup-button">Sign Up</button>

          <p className="WoSender-signup-login-link">
            Already have an account? <a href="/login">Log in</a>
          </p>
        </form>
      </div>
    </div>
  )
}

export default Signup;
